// extracted by css-extract-rspack-plugin
export default {"header":"odUPr","box":"c8e68","EmptyState":"os4Mn"};